import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import './style.css'

const WHATSAPP_NUMBER = '905317755754';

const Scrollbar = () => {

    return (
        <div className="col-lg-12">
            <div className="header-menu">
                <ul className="smothscroll">
                    <li className="whatsapp-float">
                        <a
                            href={`https://wa.me/${WHATSAPP_NUMBER}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="whatsapp-bubble"
                            title="WhatsApp ile iletişime geçin"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="26" height="26" fill="white">
                                <path d="M16 0C7.163 0 0 7.163 0 16c0 2.822.736 5.478 2.027 7.784L0 32l8.418-2.007A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.28 13.28 0 0 1-6.77-1.853l-.485-.29-5.002 1.193 1.27-4.868-.317-.5A13.244 13.244 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.274-9.93c-.398-.199-2.356-1.163-2.72-1.296-.365-.133-.63-.199-.895.199-.265.398-1.029 1.296-1.261 1.562-.232.265-.465.298-.863.1-.398-.2-1.681-.62-3.2-1.977-1.183-1.056-1.982-2.36-2.213-2.758-.232-.398-.025-.613.174-.811.179-.178.398-.465.597-.697.199-.232.265-.398.398-.663.133-.265.066-.497-.033-.697-.1-.199-.895-2.16-1.227-2.957-.323-.776-.651-.671-.895-.683l-.762-.013c-.265 0-.697.1-1.062.497-.365.398-1.394 1.362-1.394 3.322s1.427 3.852 1.626 4.117c.199.265 2.808 4.288 6.804 6.013.951.411 1.694.656 2.273.84.955.303 1.824.26 2.512.158.767-.114 2.356-.963 2.688-1.894.332-.93.332-1.728.232-1.894-.099-.166-.365-.265-.763-.464z" />
                            </svg>
                        </a>
                    </li>
                    <li><AnchorLink href='#scrool'><i className="ti-arrow-up"></i></AnchorLink></li>
                </ul>
            </div>
        </div>

    )
}

export default Scrollbar;
